import {
    RequestKeys,
} from 'app/hooks/useRequest'
import SkyNetTable from 'app/shared-components/SkyNetTable'
import SkyNetDomain, {
    getUrlsFromTableConfig, SidebarTab,
} from 'app/shared-components/SkyNetDomain'

import {
    TableControlTypes,
} from 'app/shared-components/TableControls'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import useTabsByPermission from 'app/hooks/useTabsByPermission'
import {
    ContactsTabs,
} from 'app/enums/domain.enums'
import useHasPermission from 'app/hooks/useHasPermission'
import requests from 'app/requests/Contact.requests'

import useHasContactPermissionType from '../utils/useHasContactPermissionType'
import ContactOverview from './ContactOverview'
import ContactUpdate from './ContactUpdate'
import ContactCreate from './ContactCreate'
import tableConfig from './Contacts.config'
import ContactChangeSummary from './ContactChangeSummary'
import ContactSAPContact from './ContactSAPContact/ContactSAPContact'
import {
    Contact,
} from './Contacts.types'

const tableControls: TableControlTypes[] = [
    TableControlTypes.ShowArhived,
    TableControlTypes.ClearFilters,
    TableControlTypes.ClearSorting,
]

const sapContactCondition = (data: Contact) => {
    return data?.email?.includes('@skycell.ch') && !data?.archived && Boolean(data?.user?.id)
}

const Contacts = () => {
    const sapContactVisible = useHasPermission([
        'location_sales',
        'location_bil',
        'location_cs',
        'location_cs_super',
    ])

    const tabs: SidebarTab[] = useTabsByPermission([
        {
            tab: {
                url: CommonRoutes.Overview,
                label: 'Overview',
                Component: ContactOverview,
            },
            permission: true,
        },
        {
            tab: {
                url: CommonRoutes.DataUpdate,
                label: 'Data Update',
                Component: ContactUpdate,
            },
            permission: true,
        },
        {
            tab: {
                url: ContactsTabs.SAPContact,
                label: 'SAP Employee Sync',
                Component: ContactSAPContact,
                condition: sapContactCondition,
            },
            permission: sapContactVisible,

        },
        {
            tab: {
                url: CommonRoutes.ChangeHistory,
                label: 'Change History',
                Component: ContactChangeSummary,
            },
            permission: true,
        },
    ])
    const hasCreatePermissions = useHasContactPermissionType([], 'create')

    return (
        <SkyNetDomain
            name="Contact"
            sidebarTabs={tabs}
            getDomainObject={requests.get}
            domainRequestKey={RequestKeys.getContact}
            actionComponents={{
                Create: hasCreatePermissions ? ContactCreate : undefined,
            }}
            subdomainUrls={getUrlsFromTableConfig(tableConfig)}
        >
            <SkyNetTable
                tableControls={tableControls}
                tableConfig={tableConfig}
                showSearch
            />
        </SkyNetDomain>

    )
}

export default Contacts
